import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Footer from '../components/Layout/Footer'
import NozzleOne from "../asset/metallicseal/nozzle1.png"
import NozzleTwo from "../asset/metallicseal/nozzle2.png"
import WaterOne from "../asset/metallicseal/Picture3 (1).jpg"
import SSAluminiumTransitionJoints from "../asset/SS–Aluminium Transition Joints.webp"
import PrecisionThree from '../components/Precision/PrecisionThree'
import "./ProductDetail.css";
const IndigenouslyDevelopedAssemblies = () => {
  return (
    <div className="product-detail-page">
        <NavbarTwo />
        <div className='2xl:pt-[120px] pt-[80px] xl:pt-[110px] lg:pt-[100px]'>
            
            <div className='bg-gray-200  lg:pt-24 lg:pb-6 pt-12 pb-4 px-4 lg:px-12'>
                <div className='flex items-center justify-center flex-col' >
                <h3 className='lg:text-[2.2rem] text-[1.6rem] bg-gradient-to-r from-[#99821d] via-[#ccc595] to-[#9d8944] inline-block text-transparent bg-clip-text uppercase lg:leading-[2.5rem] font-[GilroyBold]' >INDIGENOUSLY DEVELOPED ASSEMBLIES</h3>
                </div>
                <div className='py-6 grid grid-cols-1 lg:grid-cols-2 items-center lg:gap-12 gap-4 lg:py-12' >
                    <div>
                    <h5 className='text-black text-[1.2rem] font-[700] lg:text-[1.5rem]' >NOZZLE DAM ASSEMBLY</h5>
                    <p className='text-gray-600 text-[.8rem] xl:text-[1rem]' >The Nozzle Dam Assembly is used during normal shutdown and maintenance periods in a nuclear power plant to significantly shorten the time required for examining and maintaining the tubes of a steam generator, which can be performed simultaneously with refueling. The Nozzle Dam Assembly in a steam generator acts as a closure to block the flow of coolant from the inlet and outlet nozzles. These assemblies are made from aluminum and titanium materials. This Assembly is designed and developed by Hardcoats. </p>
                    </div>
                    <div className='grid grid-cols-1 my-6 xl:gap-8 gap-6 lg:grid-cols-2' >
                        <img className='rounded-lg' src={NozzleOne} />
                        <img className='rounded-lg' src={NozzleTwo} />
                        
                    </div>
                </div>
                <div className='py-6 grid grid-cols-1 lg:grid-cols-2 items-center lg:gap-12 gap-4 lg:py-12' >
                   
                    <div className='order-2 lg:order-1' >
                        <img className='rounded-lg' src={WaterOne} />
                      
                        
                    </div>
                    <div className='order-1 lg:order-2' >
                    <h5 className='text-black text-[1.2rem] font-[700] lg:text-[1.5rem]' >WATER LUBRICATED BEARING</h5>
                    <p className='text-gray-600 text-[.8rem] xl:text-[1rem]' >At Hardcoats, we specialize in the design, development, and manufacturing of high-performance water-lubricated bearings, offering a reliable solution for a range of industrial applications that require optimal performance in water-based environments. Our bearings are engineered to handle both radial and axial loads with precision, making them the ideal choice for various drive mechanisms operating exclusively under water lubrication. We offer a comprehensive range of water-lubricated bearings in sizes ranging from 16 mm to 280 mm, ensuring that each bearing is tailored to meet the specific needs of your application. Our offerings include Deep Groove, Thrust Bearing, Angular Contact and Taper Roller type Bearing.</p>
                    </div>
                </div>
                <div className='py-6 grid grid-cols-1 lg:grid-cols-2 items-center lg:gap-12 gap-4 lg:py-12' >
                    <div>
                        <h5 className='text-black text-[1.2rem] font-[700] lg:text-[1.5rem]'>SS–ALUMINIUM TRANSITION JOINTS</h5>
                        <p className='text-gray-600 text-[.8rem] xl:text-[1rem]'>Developed and manufactured indigenously for the Heavy Water Board (HWB), Government of India, these critical components were subjected to qualification testing at <a className='text-[#a38826] underline' href='https://www.linkedin.com/company/barc/' target='_blank' rel='noreferrer'>BARC</a>, Cryo-technology Division.</p>
                        <p className='text-gray-600 text-[.8rem] xl:text-[1rem] mt-4'>The results demonstrated successful performance in critical qualification tests, including:</p>
                        <ul className='text-gray-600 text-[.8rem] xl:text-[1rem] mt-3 list-disc list-inside space-y-2'>
                            <li>Helium Leak Test</li>
                            <li>Thermal Shock Test using Liquid Nitrogen</li>
                            <li>Pneumatic Pressure Test at 40 bar</li>
                        </ul>
                    </div>
                    <div>
                        <img className='rounded-lg w-full' src={SSAluminiumTransitionJoints} alt='SS–Aluminium Transition Joints' />
                    </div>
                </div>
                <PrecisionThree />
            </div>

        </div>
       
    <Footer />
    </div>
  )
}

export default IndigenouslyDevelopedAssemblies
